<section class="domain-container">
  @if(domainStatus === 'active'){
    <db-custom-domain-generated [troubleshootDomaineLoading]="troubleshootLoading"
                                (openNameservers)="openNameservers()"
                                [pointed]="pointed"
                                (troubleshootDomaine)="troubleshootDomain()"
                                [domain]="mainDomain">
    </db-custom-domain-generated>
  }@else{
  <db-custom-domain-initial-container [showUpgrade]="currentSubscription.apiResellerFree"
                                      [showActions]="!mainDomain"
                                      [currentSubscription]="currentSubscription"
                                      [user]="user"
                                      (onAddDomain)="openAddDomain()"></db-custom-domain-initial-container>
  <db-custom-domain-pointing-steps [troubleshootDomaineLoading]="troubleshootLoading"
                                   [step2Disabled]="!pointed"
                                   [pointed]="pointed"
                                   (openNameservers)="openNameservers()"
                                   (generateSLL)="generateSSL()"
                                   (removeDomain)="removeDomain()"
                                   (troubleshootDomaine)="troubleshootDomain()"
                                   *ngIf="!domainNotFound" [mainDomain]="mainDomain">
  </db-custom-domain-pointing-steps>
  }
  <db-loading-screen *ngIf="mainLoading"></db-loading-screen>
</section>
